// Migrated from app/assets/javascripts/yellow.js (inline code section)
// Yellow layout: iframe detection, body padding, responsive footer, modals, scroll

import 'jquery'
import loaderBlueGif from '@images/admin/icons/loader_blue.gif'

function inIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}
window.inIframe = inIframe;

window.submitform = function(element) {
  $(element).html($(element).data('disable-with'));
  $('form[id^="event_id_"]').submit();
  $(element).prop( "disabled", true );
}

$(document).ready(function() {

  if (inIframe()) {
    $('body').addClass('iframe');
  }

  //TOGGLE BUTTONS (radio)
  $(':input:checked').parent('.btn').addClass('active');

  //BODY PADDING
  function setBodyPadding(){
    var fh = $('footer.fixed-bottom').height();
    var hh = $('header.fixed-top').height();
    if(!$(document.body).hasClass('iframe')) {
      $(document.body).css({'padding-top' : hh+'px', 'padding-bottom' : fh+'px'});
    }
  }

  var timer = null;
  $(window).bind('resize.resizeEnd', function () {
    if (timer) { clearInterval(timer); }
    timer = setInterval(function () {
      clearInterval(timer);
      $(window).trigger('resizeEnd');

      setBodyPadding();

      var win = $(this);
      var wh = win.height();
      var ww = win.width();
      var menuWidth = 0;
      var contentWidth = $('main.content .container').width();

      //calculate menu width
      $('.steps').removeClass('medium full');
      $('nav.steps .step').each(function(){
        $('.step').addClass('invisible');
        var itemWidth = $(this).outerWidth();
        menuWidth = menuWidth + itemWidth;
      });
      menuWidth = Math.ceil(menuWidth);

      // update class
      if (ww < 768){
        $('.steps').removeClass('medium full');
      }else{
        if(menuWidth > contentWidth){
          $('.steps').removeClass('full').addClass('medium');
        }else{
          $('.steps').removeClass('medium').addClass('full');
        }
      }
      $('.step').removeClass('invisible');

    }, 50);
  }).resize();


  //FOOTER MODALS
  $('.modal_link').click(function(e) {
    var remoteUrl = $(this).attr("href");
    var targetModal = $(this).data("target");
    $(targetModal + ' .modal-content').load(remoteUrl,function(result){
      $(targetModal).modal('show');
    });
  });


  // FOOTER show/hide on small screen touch devices
  (function (a) { (jQuery.browser = jQuery.browser || {}).mobile = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4)); })(navigator.userAgent || navigator.vendor || window.opera);

  function is_touch_device() {
    var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
    var mq = function (query) {
      return window.matchMedia(query).matches;
    };
    if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
      return true;
    }
    var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
    return mq(query);
  }

  $('form').preventDoubleSubmission();
  $("a[rel^='prettyPhoto']").prettyPhoto({social_tools: ''});

  if (typeof Storage !== "undefined" && Storage !== null) {
    try {
      $('#avayo_parent_url').val(sessionStorage.getItem('avayoReturnUrl'));
    } catch (e) {
      // Full, Access denied :-(
    }
  }

  // Dialog loader using static asset path
  var num = 1;
  var $loading = $(`<img src="${loaderBlueGif}" alt="loading" />`);
  $('a[rel="dialog"]').each(function() {
    var $dialog = $('<div id="dialog-'+num+'" class="dialog"></div>')
      .append($loading.clone());
    var $link = $(this).one('click', function() {
      $dialog
        .load($link.attr('href'))
        .dialog({
          title: $link.attr('title'),
          width: 600,
          height: 450,
          modal: true
        });

      $link.click(function() {
        $dialog.dialog('open');
        return false;
      });

      return false;
    });
    num = num + 1;
  });

  // Inside iframe: smooth scroll to first field with errors
  let offsetY = 0

  // Scroll Top window -> notify parent to scroll to top of iframe
  if ( $("body.orders_update, body.orders_new").length > 0 ) {
    setTimeout(function() {
      if (window.parentIFrame) {
        parentIFrame.sendMessage({type: 'scrollToTopOfIframe', offsetY: offsetY })
      }
    }, 500);
  }

});
